import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import servicesData from '../data/services.json';
import SafeIcon from '../common/SafeIcon';

const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 bg-white rounded-t-[3rem] -mt-10 relative z-20">
      <div className="container mx-auto px-4">
        
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-brand font-black uppercase tracking-[0.2em] text-xs mb-3 block">{t('services.tagline')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            {t('services.title')}
          </h2>
          <div className="w-24 h-2 bg-brand mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service) => (
            <div 
              key={service.id} 
              className="bg-paper/40 p-10 rounded-[2rem] hover:bg-white hover:shadow-2xl hover:scale-[1.02] transition-all duration-500 border border-gray-100 hover:border-brand/10 group"
            >
              <div className="w-16 h-16 bg-white rounded-2xl shadow-md flex items-center justify-center text-brand text-3xl mb-8 group-hover:bg-brand group-hover:text-white transition-all duration-300">
                <SafeIcon name={service.icon} />
              </div>
              <h3 className="text-2xl font-black text-gray-900 mb-4">
                {t(`services.items.${service.id}.title`)}
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg">
                {t(`services.items.${service.id}.desc`)}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;